// Iter 48 — Pagina "Da sistemare": pannello admin con tutti gli avvisi di
// pulizia anagrafica/conferme, raggiungibile dalla navbar (badge contatore).
import { Link } from "react-router-dom";
import { usePendingFixes, PendingFixesSections } from "@/components/PendingFixes";
import { Button } from "@/components/ui/button";
import { CheckCircle2, RefreshCw, Wrench } from "lucide-react";

export default function DaSistemarePage() {
  const pf = usePendingFixes(true);

  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-6 space-y-4" data-testid="da-sistemare-page">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-400 font-bold">
            Pannello admin
          </div>
          <h1 className="font-heading font-extrabold text-2xl md:text-3xl flex items-center gap-2">
            <Wrench className="h-7 w-7 text-[#0044FF]" />
            Da sistemare
            {pf.loaded && pf.total > 0 && (
              <span
                className="min-w-[28px] h-[28px] px-2 rounded-full bg-orange-500 text-white text-sm font-black grid place-items-center"
                data-testid="da-sistemare-count"
              >
                {pf.total}
              </span>
            )}
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            Conferme in sospeso e dati incompleti in anagrafica: sistemali
            quando vuoi, senza aspettare il prossimo accesso.
          </p>
        </div>
        <Button
          variant="outline"
          className="h-10"
          onClick={() => pf.load()}
          data-testid="da-sistemare-refresh"
        >
          <RefreshCw className="h-4 w-4 mr-2" />
          Aggiorna
        </Button>
      </div>

      {pf.loaded && pf.total === 0 ? (
        <div
          className="rounded-2xl border-2 border-emerald-200 bg-emerald-50 p-8 text-center"
          data-testid="da-sistemare-empty"
        >
          <CheckCircle2 className="h-12 w-12 text-emerald-600 mx-auto" />
          <div className="font-heading font-bold text-lg text-emerald-900 mt-3">
            Tutto in ordine ✅
          </div>
          <p className="text-sm text-emerald-800 mt-1">
            Nessun inserimento da confermare e anagrafica completa: commesse
            con descrizione e clienti con stabilimento.
          </p>
          <div className="mt-4 flex justify-center gap-2 flex-wrap">
            <Button asChild variant="outline" className="h-9">
              <Link to="/anagrafica/commesse">Vai alle commesse</Link>
            </Button>
            <Button asChild variant="outline" className="h-9">
              <Link to="/anagrafica/clienti">Vai ai clienti</Link>
            </Button>
          </div>
        </div>
      ) : (
        <div className="space-y-2">
          <PendingFixesSections pf={pf} />
        </div>
      )}
    </div>
  );
}
